import UpgradeDialogModal from './src/UpgradeDialogModal.vue';
import { createApp, type App } from 'vue';
import { createI18n } from 'vue-i18n';
import { getCurrentLanguage } from '@eureka/language-tool';

const i18n = createI18n({
    legacy: false,
    locale: getCurrentLanguage(),
    fallbackLocale: 'en',
    messages: {},
});

let isFeatureUpgradeDialogOpen = false;

/**
 * 仅供plg || 免费用户使用
 * @returns
 */
export const openFeatureUpgradeDialog = async(params?: { functionLimit?: boolean; eventDetail?: Record<string, any> }) => {
    if (isFeatureUpgradeDialogOpen) { return }
    isFeatureUpgradeDialogOpen = true;

    const div = document.createElement('div');
    div.setAttribute('data-theme', 'patsnapRD');
    document.body.appendChild(div);

    const unmountApp = (app: App) => {
        app.unmount();
        document.body.removeChild(div);
    };

    const promise = new Promise<boolean | undefined>((resolve) => {
        const app = createApp(UpgradeDialogModal, {
            eventDetail: params?.eventDetail,
            functionLimit: params?.functionLimit,
            callback: () => {
                resolve(true);
                unmountApp(app);
                isFeatureUpgradeDialogOpen = false;
            },
        });
        app.use(i18n);
        app.mount(div);
    });

    return promise;
}
